module.exports = __webpack_public_path__ + "static/assets/df9655e4ff2a4cfbd53ce741a132fc89.png";